import { DEFAULT_ROUTER_FEATURENAME } from '@ngrx/router-store';
import { createFeatureSelector } from '@ngrx/store';
import { CustomRouterReducerState } from '../services/custom-router-store-serializer.service';

export const selectRouter = createFeatureSelector<CustomRouterReducerState>(DEFAULT_ROUTER_FEATURENAME);
